import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import API_URL from './config/apiConfig';
import {PowerIcon, EnvelopeIcon} from '@heroicons/react/24/solid';

function Header({ authToken, handleLogout }) {
    const location = useLocation();
    const [pdfStats, setPdfStats] = useState({
        used: 0,
        remaining: 0,
        total: 30
    });
    const [loadingStats, setLoadingStats] = useState(true);
    useEffect(() => {
        if (authToken?.userId) {
            axios.get(`${API_URL}/user-pdf-stats/${authToken.userId}`)
                .then(response => {
                    setPdfStats(response.data.data || {
                        used: 0,
                        remaining: 30,
                        total: 30
                    });
                })
                .catch(error => {
                    console.error('Erreur lors de la récupération des stats PDF:', error);
                })
                .finally(() => setLoadingStats(false));
        }
    }, [authToken?.userId]);


    return (
        <div
            id="nav"
            className="w-full z-20 flex flex-col md:flex-row md:justify-between md:items-center bg-[#2F4F6F] py-2 px-4 opacity-90"
        >
            {/* Gauche : Navigation admin (desktop only) */}
            <div className="hidden md:flex items-center">
                <h1 className="text-3xl font-extrabold text-white tracking-wider drop-shadow-2xl">
                    SophIA
                </h1>
            </div>

            {/* Droite : Compact user info + actions */}
            <div className="flex justify-between items-center flex-wrap gap-2 text-white text-sm">
                <div>
                    <p className="font-medium">{authToken.userName}</p>
                    {!loadingStats && (
                        <p>
                            Générations restantes : <span className="font-bold">{pdfStats.remaining}</span> / {pdfStats.total}
                        </p>
                    )}
                </div>

                <div className="flex space-x-2">
                    <a
                        href="mailto:contact@aiexpertys.fr"
                        className="bg-[#5A9BD5] text-white px-3 py-3 md:px-4 md:py-2 rounded-md hover:bg-blue-600"
                        title="Support"
                    >
                        <div className="flex items-center space-x-1">
                            <EnvelopeIcon className="w-5 h-5"/>
                            <span className="hidden md:inline">Support</span>
                        </div>
                    </a>
                    <button
                        onClick={handleLogout}
                        className="bg-red-400 text-white px-3 py-3 md:px-4 md:py-2 rounded-md hover:bg-red-600"
                        title="Déconnexion"
                    >
                        <div className="flex items-center space-x-1">
                            <PowerIcon className="w-5 h-5"/>
                            <span className="hidden md:inline">Déconnexion</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );


}


export default Header;
